import type { GenericResponse } from 'commons/modules/generic-response';
import { DEFAULT_ERROR } from 'constants/messages';
import type { ApiResponse } from './ApiResponse';

const createSuccessGenericResponse = <T>(
  data: T | null,
  httpStatus: number,
): GenericResponse<T> => ({
  data: data ?? null,
  status: httpStatus,
  success: true,
  error: null,
  errors: null,
  errorMessage: undefined,
  headers: undefined,
  allData: null,
});

export const adaptApiToGenericResponse = <T>(
  apiResponse: ApiResponse<T>,
  httpStatus: number,
): GenericResponse<ApiResponse<T>> =>
  createSuccessGenericResponse(apiResponse ?? null, httpStatus);

export const adaptDataToGenericResponse = <T>(
  data: T | null,
  httpStatus: number,
): GenericResponse<T> => createSuccessGenericResponse(data, httpStatus);

export const adaptFileToGenericResponse = <T extends BlobPart>(
  data: T | null,
  httpStatus: number,
  headers?: GenericResponse<T>['headers'],
): GenericResponse<T> => ({
  data: data ?? null,
  status: httpStatus,
  success: true,
  error: null,
  errors: null,
  errorMessage: undefined,
  headers,
  allData: null,
});

export const adaptErrorToGenericResponse = <T>(
  error: any,
  fallbackMessage?: string,
): GenericResponse<T> => ({
  data: null,
  status: error?.response?.status ?? 500,
  success: false,
  error,
  errors: error?.response?.data?.error,
  errorMessage:
    error?.response?.data?.message ?? fallbackMessage ?? DEFAULT_ERROR,
});
